// src/modules/app-views/crm/pages/Boards/tabs/VoipTab/ExtensionsList.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { Button, Empty, Input, Tag } from 'antd';
import { PhoneOutlined, SearchOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ExtensionsList = props => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { lines, userLineMapping, onCallExtension, calling } = props;

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------
  const [search, setSearch] = useState('');

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------
  const currentLineId = userLineMapping?.lineId;
  const filtered = filterLines(lines, search);

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Search input */}
      <Input
        placeholder={translateX('goto_filter_extensions')}
        prefix={<SearchOutlined />}
        value={search}
        onChange={e => setSearch(e.target.value)}
        allowClear
        style={{ marginBottom: 8 }}
      />

      {/* Scrollable list */}
      <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
        {filtered.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={translateX('goto_no_extensions')}
          />
        ) : (
          filtered.map(line => {
            const isCurrent = line.id === currentLineId;
            return (
              <div
                key={line.id}
                className={`voip-extension-item${isCurrent ? ' current-user' : ''}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '8px 12px',
                  borderRadius: 6,
                  marginBottom: 4,
                  cursor: 'pointer',
                  background: isCurrent
                    ? 'var(--ant-color-primary-bg)'
                    : 'var(--ant-color-bg-layout)',
                  border: isCurrent
                    ? '1px solid var(--ant-color-primary-border)'
                    : '1px solid transparent',
                  transition: 'background 0.2s',
                }}
              >
                <div
                  style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}
                  onClick={() => onCallExtension(line)}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <strong style={{ fontSize: 13 }}>{line.number || '-'}</strong>
                    {isCurrent && (
                      <Tag color="blue" style={{ margin: 0, fontSize: 11 }}>
                        {translateX('goto_your_extension')}
                      </Tag>
                    )}
                  </div>
                  {line.name && (
                    <div
                      style={{
                        fontSize: 12,
                        color: 'var(--ant-color-text-secondary)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {line.name}
                    </div>
                  )}
                </div>

                <Button
                  type="text"
                  size="small"
                  icon={<PhoneOutlined />}
                  onClick={() => onCallExtension(line)}
                  disabled={calling}
                  style={{ color: '#52c41a', flexShrink: 0 }}
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ExtensionsList;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function filterLines(lines, search) {
  if (!search) return lines;
  const q = search.toLowerCase();
  return lines.filter(
    line =>
      (line.number || '').toLowerCase().includes(q) ||
      (line.name || '').toLowerCase().includes(q)
  );
}
